import { FC } from 'react';
import { Outlet } from 'react-router';

import { IS_HAPPYDESK_CHAT } from '@/shared/config';
import { useHappydeskChat, useHubspotChat } from '@/shared/hooks';

const HappydeskRoutes: FC = () => {
  useHappydeskChat();
  return <Outlet />;
};

const HubspotRoutes: FC = () => {
  useHubspotChat();
  return <Outlet />;
};

export const ChatRoutes: FC = () => {
  if (IS_HAPPYDESK_CHAT) {
    return <HappydeskRoutes />;
  }
  return <HubspotRoutes />;
};
